import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.7513 8.20735L14.9177 8.49276L15.2406 8.56261L20.1618 9.6271C20.3492 9.66762 20.4231 9.89525 20.2953 10.0381L16.941 13.788L16.7205 14.0345L16.7538 14.3636L17.2611 19.3681C17.2804 19.5587 17.087 19.6993 16.9116 19.6221L12.3022 17.5931L12 17.4601L11.6978 17.5931L7.08836 19.6221C6.91303 19.6993 6.7196 19.5587 6.73892 19.3681L7.24618 14.3636L7.27954 14.0345L7.05899 13.788L3.70468 10.0381L3.14569 10.5381L3.70468 10.0381C3.57688 9.89525 3.6508 9.66762 3.83816 9.6271L8.75938 8.56261L9.08229 8.49276L9.24872 8.20735L11.784 3.85931C11.8805 3.69388 12.1195 3.69388 12.216 3.85931L14.7513 8.20735Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
